import _ from 'lodash'
import {
  buildUrl
} from '@/util.js'
export default {
  namespaced: true,
  actions: {
    async r ({dispatch, rootState, rootGetters}, options) {
      let key = 'ranch'
      let url = options.url
      options.url = buildUrl(rootGetters.rootDomain, key, url)
      options.method = 'post'

      let authFailReLaunch = false
      if (options.hasOwnProperty('authFailReLaunch')) {
        authFailReLaunch = options.authFailReLaunch
        delete options.authFailReLaunch
      }
      let res = await dispatch('api/r', options, {root: true})

      let code = _.get(res, 'data.code')
      if (code === 0) {
        return _.get(res, 'data.data')
      }

      if (authFailReLaunch && code === 2205) { // auth failed, force relogin
        // await dispatch('me/logout', null, {root: true})
        window.reload()
        throw new Error(`登入授权失效，请重新登入`)
      }

      let msg = _.get(res, 'data.msg', `请求失败。`)
      let moreInfo = [key, url, res.status, code]
      if (msg) {
        if (code === 5233) { // 投遞訂單不存在
          moreInfo.push(JSON.stringify(options.data))
        }
      }
      if (rootState.env === 'prod') {
        msg = `${msg}(${moreInfo.join(', ')})`
      }
      throw new Error(msg)
    },
    async userSignIn ({dispatch}, {
      type = 2,
      uid,
      password = 'dartcome.web'
    }) {
      let data = await dispatch('r', {
        url: '/user/sign-in',
        data: {
          type,
          uid,
          password
        }
      }, {
        headers: {
          'tephra-session-id': uid
        }
      })
      return data
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/api/ranch/index.js